import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type FullInfo = components['schemas']['FullInfo'];

type FetchProfileOperation = paths['/executor_web/profile']['get'];

export type FetchProfileResponse = FetchProfileOperation['responses'][200]['content']['application/json'];

/** GET `/executor_web/profile` — см. `paths['/executor_web/profile']` в auth swagger */
export function fetchProfile(signal?: AbortSignal) {
	return axiosInstance.get<FetchProfileResponse>('profile', {signal});
}
